export default __webpack_public_path__ + "static/media/sleepIconSemSobra.85f0a2ef.svg";